/**
 * Liefert die Primär-URL eines Termins.
 *
 * Wenn `landing_page_url` gesetzt ist, führt sowohl der „Mehr Infos"- als
 * auch der „Anmelden"-Button auf diese Landingpage. Andernfalls Fallback
 * auf die Standard-Detailseite `/termin/:slug`.
 *
 * `null` bedeutet: kein Slug hinterlegt → aufrufende Komponente muss den
 * bisherigen Modal-Fallback nutzen.
 */
export interface TerminUrlInput {
  slug?: string | null;
  landing_page_url?: string | null;
}

export function getTerminPrimaryUrl(termin: TerminUrlInput): string | null {
  const custom = termin.landing_page_url?.trim();
  if (custom) return custom;
  if (termin.slug) return `/termin/${termin.slug}`;
  return null;
}

/** True, wenn der Termin auf eine eigene Landingpage zeigt. */
export function hasCustomLandingPage(termin: TerminUrlInput): boolean {
  return Boolean(termin.landing_page_url?.trim());
}
